import React from "react";
import { Box, Card, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { CardTitle, CardDesc } from "../../../elements/color-cta-cards/styles";

interface CardProps {
  closeHeaderMenu?: () => any;
  title: string;
  desc: string;
  ctaLink: string;
  btnLabel: string;
}

const cardStyles = {
  padding: "18px",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const chipStyles = {
  display: "inline-block",
  backgroundColor: "rgba(255,255,255,0.2)",
  color: "#FFFFFF",
  fontSize: "8px",
  fontWeight: 700,
  borderRadius: "6px",
  padding: "4px 8px",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  mb: 0.5,
  backdropFilter: "blur(4px)",
};

const btnStyles = {
  background: "#FFF",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px",
  textAlign: "center",
  textTransform: "uppercase",
  borderRadius: "8px",
  padding: "8px 12px",
  width: "100%",
  mt: 3,
  "&:hover": { background: "#FFF" },
};

export const RedCard: React.FC<CardProps> = ({
  closeHeaderMenu,
  title,
  desc,
  ctaLink,
  btnLabel = "PRENDRE RENDEZ-VOUS",
}) => {
  const navigate = useNavigate();

  const onCtaClick = () => {
    closeHeaderMenu && closeHeaderMenu();
    navigate(ctaLink);
  };

  return (
    <Card sx={{ ...cardStyles, backgroundColor: "#C41E3B" }}>
      <Box>
        <Box sx={chipStyles}>AIDE</Box>
        <CardTitle style={{ color: "#FFFFFF", fontSize: "20px", lineHeight: "24px", marginBottom: "8px" }}>
          {title}
        </CardTitle>
        <CardDesc style={{ color: "#FFFFFF", fontSize: "13px", lineHeight: "19px", fontWeight: 600 }}>{desc}</CardDesc>
      </Box>
      <Button
        variant="contained"
        sx={{
          ...btnStyles,
          color: "#C41E3B",
        }}
        onClick={onCtaClick}>
        {btnLabel}
      </Button>
    </Card>
  );
};

export const BlueCard: React.FC<CardProps> = ({ closeHeaderMenu, title, desc, ctaLink, btnLabel }) => {
  const navigate = useNavigate();

  const onCtaClick = () => {
    closeHeaderMenu && closeHeaderMenu();
    navigate(ctaLink);
  };

  return (
    <Card sx={{ ...cardStyles, backgroundColor: "#5D89A2" }}>
      <Box>
        <Box sx={chipStyles}>SERVICES</Box>
        <CardTitle style={{ color: "#FFFFFF", fontSize: "20px", lineHeight: "24px", marginBottom: "8px" }}>
          {title}
        </CardTitle>
        <CardDesc style={{ color: "#FFFFFF", fontSize: "13px", lineHeight: "19px", fontWeight: 600 }}>{desc}</CardDesc>
      </Box>
      <Button variant="contained" onClick={onCtaClick} sx={{ ...btnStyles, color: "#3D6881" }}>
        {btnLabel}
      </Button>
    </Card>
  );
};
